import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FiHome, FiGift, FiKey, FiWifi, FiBook } from "react-icons/fi";
import "./BottomNav.scss";

interface BottomNavProps {
  className?: string;
}

function BottomNav({ className = "" }: BottomNavProps) {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const navItems = [
    { icon: <FiHome size={20} />, label: t("nav.home"), path: "/admin/home" },
    { icon: <FiGift size={20} />, label: t("nav.upgrades"), path: "/admin/upgrades" },
    { icon: <FiWifi size={20} />, label: t("nav.wifi"), path: "/admin/wifi" },
    { icon: <FiBook size={20} />, label: t("nav.guides"), path: "/admin/guides" },
    { icon: <FiKey size={20} />, label: t("nav.access"), path: "/admin/access" },
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className={`bottom-nav ${className}`}>
      <div className="bottom-nav__container">
        {navItems.map((item, index) => {
          const active = isActive(item.path);
          return (
            <div
              key={index}
              onClick={() => navigate(item.path)}
              className={`bottom-nav__item ${active ? "bottom-nav__item--active" : ""}`}
            >
              <div className="bottom-nav__icon">{item.icon}</div>
              <span className="bottom-nav__label">{item.label}</span>
            </div>
          );
        })}
      </div>
      <div className="bottom-nav__footer">
        <span className="bottom-nav__footer-text">Powered by</span>
        <img
          src="https://steasyhubprodus.blob.core.windows.net/public/logo-white.png"
          alt="EasyHub"
          className="bottom-nav__footer-logo"
        />
      </div>
    </nav>
  );
}

export default BottomNav;
